import $api from "@/api/index";
import {
  HexGroupI,
  AgglomerationI,
  PriceRangesI,
  AgglomerationsPriceRanges,
} from "@/types/base";

export async function getAgglomeration(): Promise<AgglomerationI[]> {
  const response = await $api.get<{ data: AgglomerationI[] }>(
    "/v2/agglomerations"
  );

  return response.data.data;
}

export async function getHexgroupsByLocation({
  lon,
  lat,
}: {
  lon: number;
  lat: number;
}): Promise<HexGroupI> {
  const response = await $api.get<{ data: HexGroupI }>(
    "/v2/hexgroups/nearest",
    {
      params: { lon, lat },
    }
  );

  return response.data.data;
}

export async function getPriceRanges(): Promise<PriceRangesI[]> {
  const response = await $api.get<{ data: PriceRangesI[] }>(
    "/v2/hexgroups/prices"
  );

  return response.data.data;
}

export async function getSnapshotPriceRanges(): Promise<
  Record<string, PriceRangesI[]>
> {
  const response = await $api.get<{ data: Record<string, PriceRangesI[]> }>(
    "/v2/snapshots/hexagons/prices"
  );

  return response.data.data;
}

export async function getAgglomerationsPriceRanges(): Promise<AgglomerationsPriceRanges> {
  const response = await $api.get<{ data: AgglomerationsPriceRanges }>(
    "/v2/agglomerations/prices"
  );

  return response.data.data;
}
